export class RoomWaitingEventApi {
    #isRunEvent = false;
    #eventQueue = [];
    #eventListenersMap = {};

    constructor(options={}) {
    }

    addEventListener(type, listener, options) {
        let list = this.#eventListenersMap[type];
        if(!list){
            this.#eventListenersMap[type] = list = [];
        }
        list.push({
            listener, options
        });
        return this;
    }
    addEventListeners(listeners, instance=this) {
        if(Array.isArray(listeners)){
            listeners.forEach(o => {
                o.listener = o.listener.bind(instance);
                this.addEventListener(o.type, o.listener);
            });
        }else if(typeof listeners === 'object'){
            for(let type in listeners){
                let listener = listeners[type] = listeners[type].bind(instance);
                this.addEventListener(type, listener);
            }
        }
    }

    removeEventListeners(listeners) {
        if(Array.isArray(listeners)){
            listeners.forEach(o => {
                this.removeEventListener(o.type, o.listener);
            });
        }else if(typeof listeners === 'object'){
            for(let type in listeners){
                this.removeEventListener(type, listeners[type]);
            }
        }
    }

    removeEventListener(type, listener) {
        let list = this.#eventListenersMap[type];
        if(!list){
            return this;
        }

        if(!listener){
            delete this.#eventListenersMap[type];
            return this;
        }

        for(let i=0; i<list.length; i++){
            if(list[i].listener !== listener){
                continue;
            }
            list.splice(i, 1);
            break;
        }

        return this;
    }

    async trigger(type, data) {
        let e = null;
        if(typeof type === 'object'){
            e = type;
            type = e.type;
        }

        let list = this.#eventListenersMap[type];
        if(!list){
            // console.warn('unknown event :', type, data);
            return this;
        }

        if(!e){
            e = {
                type,
                data,
                eventTime: new Date()
            };
        }

        let works;
        for(let i=0; i<list.length; i++){
            let obj = list[i];
            let rt = obj.listener(e);
            if(rt instanceof Promise){
                if(!works) works = [];
                works.push(rt);
            }

            if(obj.options && obj.options.once){
                list.splice(i, 1);
                i--;
            }
        }

        if(works){
            let result = await Promise.all(works);
            return result;
        }
        return;
    }

    async pushEvent(event, data) {
        if(typeof event === 'string'){
            event = {
                type: event,
                data
            };
        }

        this.#eventQueue.push(event);
        await this._runEvent()
    }

    async _runEvent() {
        if(!this.#isRunEvent) return;

        let event;
        while(
            (event = this.#eventQueue.shift())
        ){
                await this.trigger(event);
        }
    }

    pauseEvent() {
        this.#isRunEvent = false;
        return this;
    }

    async runEvent() {
        this.#isRunEvent = true;
        await this._runEvent();
        return this;
    }
}

export const roomWaitingEventApi = new RoomWaitingEventApi();